import "../scss/styles.scss";
import AOS from "aos";
import "aos/dist/aos.css";

import lozad from "lozad";

/* import "lightbox2/dist/css/lightbox.css";
import "lightbox2/dist/js/lightbox.js"; */

const el = document.querySelector("img");
const observer = lozad(el); // passing a `NodeList` (e.g. `document.querySelectorAll()`) is also valid
observer.observe();

jQuery(($) => {
	AOS.init();

	$(window).on("load", function () {
		AOS.refresh();
	});

	/****************** Change datapicker icon ******************/

	if ($(".ui-datepicker-trigger").length > 0) {
		$(".ui-datepicker-trigger").attr(
			"src",
			"/wp-content/themes/unitedstations/assets/dist/images/datepicker.svg"
		);
	}

	/****************** HAMBURGERS MENU ******************/

	$("#header").on("click", "button.navbar-toggler", function () {
		$(this).toggleClass("is-active");
		$("main#main").toggleClass("is--open");
		$("nav#header").toggleClass("menu-open");
		$("body").toggleClass("is--open");
	});

	/****************** HIDE NAVBAR WHEN SCROLLING ******************/

	if ($(window).width() < 768) {
		let prevScrollPos = $(window).scrollTop();
		const header = $("#header");
		let isScrolling;

		//console.log("window width < 768");

		var distance = $("#main").offset().top,
			$window = $(window);

		$window.on("scroll", function () {
			if ($window.scrollTop() >= distance) {
				const currentScrollPos = $(window).scrollTop();
				if (prevScrollPos > currentScrollPos) {
					header.removeClass("hidden__scroll");
					//console.log("removeClass hidden__scroll");
				} else {
					header.addClass("hidden__scroll");
					//console.log("addClass hidden__scroll");
				}
				prevScrollPos = currentScrollPos;
			}
		});
	}

	//makeClickable(document.body);
});

/* function makeClickable(text) {
	// Regular expressions to match email addresses and phone numbers
	var emailRegex = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/g;
	var phoneRegex =
		/(\+\d{1,2}\s?)?(\(\d{3}\)|\d{3})[-.\s]?\d{3}[-.\s]?\d{4}/g;

	// Replace email addresses with clickable links
	var textWithEmailLinks = text.replace(
		emailRegex,
		'<a href="mailto:$1">$1</a>'
	);

	// Replace phone numbers with clickable links
	var textWithPhoneLinks = textWithEmailLinks.replace(
		phoneRegex,
		'<a href="tel:$&">$&</a>'
	);

	return textWithPhoneLinks;
} */
